module.exports = __webpack_public_path__ + "static/media/donated_complated.d1c75bef.svg";